<div class="container products">
  <h2 class="page-header">Producten</h2>
  <div class="form-title">
    <div class="form-title-text">
      <span>Item</span> <span class="pull-right">Acties</span>
    </div>
  </div>
  <div class="product-list">
    <div
      class="product d-flex"
      [routerLink]="['/producten', product]"
      *ngFor="let product of products"
    >
      <span class="list-item flexer">{{ product }}</span>
      <button class="edit-button btn btn-sm pull-right" mat-icon-button>
        <mat-icon svgIcon="edit"></mat-icon>
      </button>
    </div>
    <div
      class="product d-flex"
      [routerLink]="['/producten', 'plaatsingsprijs-ip-borden']"
    >
      <span class="list-item flexer">Plaatsingsprijs IP-borden</span>
      <button class="edit-button btn btn-sm pull-right" mat-icon-button>
        <mat-icon svgIcon="edit"></mat-icon>
      </button>
    </div>
  </div>
</div>
